/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ServiceCategories {
    "use strict";

    export class ServiceCategoriesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        private busyService: Meevo.Components.Busy.IBusyService;
        private imageGalleryService: any;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            busyService: Meevo.Components.Busy.IBusyService,
            imageGalleryService: Meevo.Components.Common.IImageGalleryService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.busyService = busyService;
            this.imageGalleryService = imageGalleryService;
            //this.buildCrudSecurityKeysBase(this.securityKeys.DATA_SERVICECATEGORY_TAB_MAIN, true, true, false, false, true);
            this.initializeSections();
        }

        initializeContext(): void {
            // initialize end points
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.serviceCategory;
            // initialize templatepaths
            this.sectionTemplatePath = "app/plugins/serviceCategories/sectionViews/";

        }

        initializeSections(): void {
            this.initializeContext();
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_SERVICECATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new MainSection(0,
                    "SECTION_SERVICES_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ServiceCategoryMain,
                    null,
                    this.securityKeys.DATA_SERVICECATEGORY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_SERVICECATEGORY_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ImageGallerySection(1,
                    'SECTION_IMAGE_GALLERY',
                    'imageGallery.html',
                    false,
                    true,
                    '',
                    'imagegallery',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ServiceCategoryImageGalleryTab,
                    this.modalService,
                    this.imageGalleryService,
                    this.securityKeys.DATA_SERVICECATEGORY_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeys(this.securityKeys.DATA_SERVICECATEGORY_TAB_IMAGEGALLERY);
                    break;
                default:
                    this.buildCrudSecurityKeys(this.securityKeys.DATA_SERVICECATEGORY_TAB_MAIN);
                    break;
            }
            super.selectSection(item);
        }

        get allowTakeOwnership(): boolean {
            return false;
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;

            var canAppendLocationId = !this.isApplicationModeCO() && (this.identityService.current().callCenterId !== this.identityService.current().locationId);
            // Get TenantDistribution model and build url
            this.dataService.customMethodData("api/tenant/businessinfo/meevourl", "GET", null)
                .then((result: any) => {
                    if (result && result.data && result.data.meevoUrl) {
                        this.obAppServiceCatUrl = `${result.data.meevoUrl}/${result.data.subDomainUrl}/${result.data.onlineBookingApp}`;
                        if (canAppendLocationId) {
                            this.obAppServiceCatUrl += `?locationId=${this.identityService.current().locationId}`;
                        }
                    }
                    else {
                        this.obAppServiceCatUrl = `${window['OnlineBookingBaseUrl']}index.html?tenantId=${this.identityService.current().tenantId}`;
                        if (canAppendLocationId) {
                            this.obAppServiceCatUrl += `&locationId=${this.identityService.current().locationId}`;
                        }
                    }

                    this.obAppServiceCatUrl += `&serviceCat=${this.selectedSection.model.id}`;
                });
        }


        save(): angular.IPromise<any> {
            var subCats = (<Meevo.Model.ServiceCategory>this.selectedSection.model).subCategories;
            var mainCat=(<Meevo.Model.ServiceCategory>this.selectedSection.model);           
                _.filter(subCats,
                    (sc: any) => {
                        if (Model.Guard.isNothing(sc.backgroundColor)) {
                            sc.backgroundColor = mainCat["backgroundColor"];
                        }
                        return sc;
                    });
                return super.save();
        }

        preSave() {
            var subCats = (<Meevo.Model.ServiceCategory>this.selectedSection.model).subCategories;
            if (!Model.Guard.isSomething(subCats) || subCats.length < 1) {
                this.busyService.stop();
                this.modalService.error("MESSAGE_SUBCAT_REQUIRED", Components.Modal.ModalTranslationModes.Translate);
            } 
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.ServiceCategory>();
            model.subCategories.forEach(subCat => subCat.id = null);
            model.displayName = undefined;
        }

        private _obAppServiceCatUrl: string = '';

        get obAppServiceCatUrl(): string {
            return this._obAppServiceCatUrl;
        }
        set obAppServiceCatUrl(value: string) {
            this._obAppServiceCatUrl = value;
        }

    }
}